module.exports = __webpack_public_path__ + "img/8.87b2b641.png";